import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'

import { fetchOrganizations, getOrganizations } from 'ducks/organizations'

import Modal from 'components/Shared/Modal'
import WrappedInput from 'components/Shared/Forms/WrappedInput'
import WrappedSelect from 'components/Shared/Forms/WrappedSelect'
import WrappedRadio from 'components/Shared/Forms/WrappedRadio'

import './CopyApp.css'

class OrganizationSelect extends Component {
  componentDidMount() {
    const { fetchOrganizations } = this.props

    fetchOrganizations()
  }

  getOptions() {
    const { organizations } = this.props

    return Object.values(organizations).map(org => ({
      label: org.name,
      value: org.id,
    }))
  }

  render() {
    const options = this.getOptions()

    if (options.length <= 1) {
      return null
    }

    return <WrappedSelect {...this.props} options={options} />
  }
}

const mapStateToProps = state => ({
  organizations: getOrganizations(state),
})

const ConnectedOrgSelect = connect(mapStateToProps, { fetchOrganizations })(
  OrganizationSelect
)

class CopyAppForm extends Component {
  render() {
    const { onCancel, handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Modal.Header title="Copy App" />
        <Modal.Content>
          <Field
            autoSelect
            name="name"
            label="Name"
            component={WrappedInput}
            placeholder="My App Copy"
          />
          <div className="copy-app-radios">
            <Field
              styled
              component={WrappedRadio}
              name="copyDatabase"
              radioValue="1"
              label="Copy database"
            />
            <Field
              styled
              component={WrappedRadio}
              name="copyDatabase"
              radioValue="0"
              label="Share the same database"
            />
          </div>
          <Field name="organizationId" component={ConnectedOrgSelect} />
        </Modal.Content>
        <Modal.Actions>
          <Modal.Button type="button" text onClick={onCancel}>
            Cancel
          </Modal.Button>
          <Modal.Button type="submit">Copy</Modal.Button>
        </Modal.Actions>
      </form>
    )
  }
}

export default reduxForm({ form: 'copyDatabaseForm' })(CopyAppForm)
